import { apiRequest } from './client'

export interface VersionEntry {
  version_id: string
  label: string
  created_by: string
  created_at: string
  parents: string[]
}

export interface VersionListResponse {
  head: string | null
  versions: VersionEntry[]
}

// Every call is canvas-scoped. `canvasId` is REQUIRED rather than defaulted:
// these functions used to send no canvas at all, so the backend fell back to
// the `agent` canvas and Restore from a secondary canvas overwrote it.
function canvasQuery(canvasId: string): string {
  return `canvas_id=${encodeURIComponent(canvasId)}`
}

export async function fetchVersions(projectId: string, canvasId: string): Promise<VersionListResponse> {
  return apiRequest(`/projects/${projectId}/canvas/versions?${canvasQuery(canvasId)}`)
}

export async function createVersion(projectId: string, canvasId: string, label: string): Promise<VersionEntry> {
  return apiRequest(`/projects/${projectId}/canvas/versions?${canvasQuery(canvasId)}`, {
    method: 'POST',
    body: JSON.stringify({ label }),
  })
}

export async function restoreVersion(projectId: string, canvasId: string, versionId: string): Promise<void> {
  return apiRequest(`/projects/${projectId}/canvas/versions/${versionId}/restore?${canvasQuery(canvasId)}`, {
    method: 'POST',
  })
}

export async function deleteVersion(projectId: string, canvasId: string, versionId: string): Promise<{ deleted: string[] }> {
  return apiRequest(`/projects/${projectId}/canvas/versions/${versionId}?${canvasQuery(canvasId)}`, {
    method: 'DELETE',
  })
}

export async function diffVersions(projectId: string, canvasId: string, versionA: string, versionB: string): Promise<{ diff: string }> {
  return apiRequest(
    `/projects/${projectId}/canvas/versions/diff?${canvasQuery(canvasId)}&version_a=${encodeURIComponent(versionA)}&version_b=${encodeURIComponent(versionB)}`,
  )
}
